<div class="card form-card">
    <!-- <div class="card-header">
        <h3 class="mb-1">Organization Details</h3>
        <small>Enter organization information below</small>
    </div> -->

    <div class="card-body p-4">
        <div class="row g-3">
            <div class="col-md-3">
                <label class="form-label">
                    Org. Code
                    <span class="required">*</span>
                </label>
                <input type="text" class="form-control" [(ngModel)]="frmData.org_code" 
                    placeholder="Enter organization name" disabled>
            </div>
            <div class="col-md-9">
                <label class="form-label">
                    Organization Name
                    <span class="required">*</span>
                </label>
                <input type="text" class="form-control" [(ngModel)]="frmData.org_name" 
                    placeholder="Enter organization name" [disabled]="isReadonly">
            </div>
        </div>
        <div class="row g-3 mt-1">
            <div class="col-md-8">
                <label class="form-label">Address</label>
                <textarea class="form-control" [(ngModel)]="frmData.org_address" rows="5" [disabled]="isReadonly"></textarea>
            </div>
            <div class="col-md-4">
                <label class="form-label">State/City/Pincode</label>
                <div class="mb-2">
                    <!-- <label class="form-label">
                        State
                    </label> -->
                    <select class="form-select" [(ngModel)]="frmData.org_state" [disabled]="isReadonly"
                        (change)="districts = dataService.getDist(frmData.org_state)">
                        <option>Select State</option>
                        @for(st of dataService.cityDataDD; track $index) {
                        <option>{{st.state}}</option>
                        }
                    </select>
                </div>
                <div class="mb-2">
                    <!-- <label class="form-label">
                        City
                    </label> -->
                    <select class="form-select" [(ngModel)]="frmData.org_city" [disabled]="isReadonly">
                        <option>Select City</option>
                        @for(dist of districts; track $index) {
                        <option>{{dist}}</option>
                        }
                    </select>
                </div>
                <input type="number" class="form-control" [(ngModel)]="frmData.org_pincode" 
                    placeholder="Pincode" [disabled]="isReadonly">
            </div>
        </div>
    </div>
</div>
